export const SEARCHFORM_FALLBACK_TRANSLATIONS = {
    startDateLabel: 'Check-in',
    endDateLabel: 'Check-out',
    modalTitleStartDateMessage: 'Select your check-in date',
    modalTitleEndDateMessage: 'Select your check-out date',
    clearButtonLabel: 'Clear',
    closeButtonLabel: 'Close',
    continueButtonLabel: 'Continue',
    selectDateHintMessage: 'Choose check-out date',
    nightsText: 'Nights: ',

    separatorText: ', ',
    adultText: 'Adult',
    adultsText: 'Adults',
    zeroAdultsText: 'Adults',
    ageSelectSubtitle: 'This helps us show you a more accurate price',
    ageSelectTitle: 'How old are the children?',
    ageSelectTitleSingular: 'How old is the child?',
    childText: 'Child',
    childrenText: 'Children',
    zeroChildrenText: 'Children',
    guestText: 'Guest',
    guestsText: 'Guests',
    petsText: 'Pets',
    onlyPetsText: 'Pets',
    label: 'Guests',
    modalTitle: 'Select guests',
    petLabel: 'Pets',
    petNoLabel: 'No',
    petYesLabel: 'Yes',
    petMessage: 'Only properties that allow pets will be shown',
    applyButtonLabel: 'Apply',
    addDates: 'Add dates',
    addGuests: 'Add guests',

    errorMessageText: 'Tell us where you’re traveling',
    noResultsFoundMessage: 'No results found',
    placeholderMessage: 'Where to?',
    whereLabel: 'Where',
    nearByDestinationsMessage: 'Nearby destinations',

    checkAvailabilityLabelText: 'Check Availability',
    searchLabelText: 'Search',

    titleMessage: 'Search'
};